import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AxABasketError} from '../_models';
import { CatalogService } from '../_services';

declare const $:any;

@Component({
  selector: 'app-login-axa-error-modal',
  templateUrl:'./login-axa-error-modal.component.html',
  styleUrls: ['./login-axa-error-modal.component.css']
})
export class LoginAxaErrorModalComponent implements OnInit {
  imgProduct:string;

  constructor(
    public catalog : CatalogService,
    public translate : TranslateService,
  ) {}

  ngOnInit() {

  }

  @Input() title : string;
  @Input() id : number;
  @Input() array : any[];
  @Output() close = new EventEmitter<boolean>();



  public errors :  AxABasketError[] = [];

  onClose(ok: boolean) {
    this.close.emit(ok);
  }

  show(title: string = null, arr: any = null) {
    this.errors = [];
   // console.log(arr);
    if (title)
      this.title = title;
    if (arr)
      this.array = arr;

    for (var key in arr) {
      if (arr.hasOwnProperty(key)){
        let error : AxABasketError = new AxABasketError(arr[key]);
        this.errors.push(error);

      }
    }


    $('#modal-axa-error-' + this.id).modal('show');

  }






}



